export  const  STORE_USER_DATA = "STORE_USER_DATA"
export  const  SETUP_USER_ERROR = "SETUP_USER_ERROR"
export  const  STORE_PANEL_DATA = "STORE_PANEL_DATA"
export  const  SETUP_PANEL_ERROR = "SETUP_PANEL_ERROR"
export  const  LOGOUT_USER_BEGIN = "LOGOUT_USER_BEGIN"
export  const  LOGOUT_USER = "LOGOUT_USER"
export  const  LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR"